import Vue from "vue";
import Vuetify, { VTextField } from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  theme: {
    themes: {
      dark: {
        primary: "#f58122",
        secondary: "#ffde2d",
        anchor: "#ed2024",
        success: "#00C853",
        background: "#edffea"
      },
      light: {
        primary: "#f58122",
        secondary: "#ffde2d",
        anchor: "#ed2024",
        success: "#00C853",
        background: "#edffea"
      }
    }
  },
  components: {
    VTextField
  }
});
